import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { connectionsActions } from '@store/connections/connections.slice';
import { consumersActions } from '@store/consumers/consumers.slice';

import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useLazyGetAccessTokenQuery } from '@hook/consumer/consumer.hooks';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { isExist, isString } from '@util/data/is-exist';

import { ConsumerViewTabEnum } from './consumer-view.tab-enum';

export const useConsumerView = () => {
  const dispatch = useStoreDispatch();
  const { consumerId = '', consumerTab = ConsumerViewTabEnum.Integrations } = useParams();
  const { data: consumers, meta } = useStoreSelector((state) => state.consumers);
  const isCredentialsExist = useStoreSelector((state) => state.credentials.data.length > 0);
  const consumer = consumers[consumerId];

  const { action: getAccess } = useLazyQuery(
    useLazyGetAccessTokenQuery(),
    consumersActions,
    consumersActions.setAccess,
  );

  useEffect(
    () => void (isCredentialsExist && !isString(meta.accessToken) && isExist(consumer) && getAccess(consumer)),
    [consumer, meta.accessToken, getAccess, isCredentialsExist],
  );

  useEffect(
    () => () => {
      void dispatch(consumersActions.resetAccess());
      void dispatch(connectionsActions.reset());
    },
    [],
  );

  return { consumer: consumers[consumerId], consumerTab };
};
